import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import { Drawer, IconButton, List, ListItem, Typography } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

export default function PdfAppBar({
  mobileOpen,
  showTerms,
  lessThanXL,
  scrollToTopAndShowMainPage,
  scrollToAbout,
  scrollToAboutAndShowMainPage,
  scrollToBottom,
}) {
  const onLogin = () => {
    window.location = "https://app.dokusense.ai/" as any;
  };

  const [state, setState] = React.useState(false);

  const toggleDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      setState(open);
    };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        sx={{
          bgcolor: "#F2F1ED",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        elevation={0}
        position="absolute"
      >
        <Toolbar sx={{ minHeight: "90px", height: "90px" }}>
          <Box
            sx={{
              display: "flex",
              flexGrow: "1",
              paddingLeft: !lessThanXL ? "45px" : "10px",
              paddingRight: !lessThanXL ? "45px" : "10px",
            }}
          >
            <Box sx={{ flexGrow: 1, marginTop: "10px" }}>
              <Typography
                onClick={scrollToTopAndShowMainPage}
                sx={{
                  color: "#1F1F1F",
                  userSelect: "none",
                  fontSize: !lessThanXL ? "32px" : "28px",
                  fontStyle: "normal",
                  fontWeight: "400",
                  lineLeight: "normal",
                  fontFamily: "Righteous",
                }}
                variant="h1"
                component="div"
              >
                <span style={{ cursor: "pointer" }}>DokuSense</span>
              </Typography>
            </Box>

            {lessThanXL ? (
              <IconButton
                onClick={toggleDrawer(true)}
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
              >
                <MenuIcon />
              </IconButton>
            ) : (
              ""
            )}

            <Drawer
              PaperProps={{
                sx: {
                  backgroundColor: "#FFFFFF",
                },
              }}
              anchor={"left"}
              open={state}
              onClose={toggleDrawer(false)}
            >
              <Box
                sx={{
                  width: "150px",
                }}
                onClick={toggleDrawer(false)}
                onKeyDown={toggleDrawer(false)}
              >
                <List sx={{ marginTop: "70px" }}>
                  <ListItem>
                    <Button
                      onClick={onLogin}
                      sx={{ color: "#1F1F1F" }}
                      color="primary"
                      aria-label="login"
                    >
                      Login
                    </Button>
                  </ListItem>
                  <ListItem>
                    <Button
                      onClick={
                        showTerms ? scrollToAboutAndShowMainPage : scrollToAbout
                      }
                      sx={{ marginRight: "20px", color: "#1F1F1F" }}
                      color="primary"
                      aria-label="about"
                    >
                      About
                    </Button>
                  </ListItem>

                  <ListItem>
                    <Button
                      onClick={scrollToBottom}
                      variant="contained"
                      aria-label="Request access to DokuSense"
                      sx={{ backgroundColor: "#466A88", borderRadius: "14px" }}
                    >
                      Request access
                    </Button>
                  </ListItem>
                </List>
              </Box>
            </Drawer>
            {!lessThanXL ? (
              <>
                <Button
                  onClick={
                    showTerms ? scrollToAboutAndShowMainPage : scrollToAbout
                  }
                  sx={{ marginRight: "20px", color: "#1F1F1F" }}
                  color="primary"
                  aria-label="about"
                >
                  About
                </Button>
                <Button
                  onClick={onLogin}
                  sx={{ marginRight: "20px", color: "#1F1F1F" }}
                  color="primary"
                  aria-label="login"
                >
                  Login
                </Button>

                <Button
                  onClick={scrollToBottom}
                  variant="contained"
                  aria-label="Request access to DokuSense"
                  sx={{ backgroundColor: "#466A88", borderRadius: "14px" }}
                >
                  Request access
                </Button>
              </>
            ) : (
              ""
            )}
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
